var jade = require("/home/runner/work/banquetNinja/banquetNinja/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div ng-show=\"vm.isLoading\">Working...</div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/common/widgets/isLoading.jade
// module id = 525
// module chunks = 0